import { defineEntity, custom } from './_helpers.js';

export default defineEntity('dataProcessingAgreement', {
    subProcessorAdded: custom({ scope: 'state' }),
    subProcessorDecided: custom({ scope: 'state' }),
    deadlineReminder: custom({ scope: 'state' }),
    expired: custom({ scope: 'state' }),
});
